export const bell_animation = {
    v: '5.8.1',
    fr: 60,
    ip: 0,
    op: 96,
    w: 430,
    h: 430,
    nm: 'wired-outline-193-bell-notification',
    ddd: 0,
    assets: [
        {
            id: 'comp_1',
            nm: 'hover-ring',
            fr: 60,
            layers: [
                {
                    ddd: 0,
                    ind: 1,
                    ty: 4,
                    nm: 'Warstwa 4',
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: {
                            a: 1,
                            k: [
                                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] },
                                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 6, s: [-19] },
                                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 12, s: [10] },
                                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 18, s: [-10] },
                                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 24, s: [10] },
                                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [-10] },
                                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 44.4, s: [4] },
                                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 49.801, s: [-2] },
                                { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 56.4, s: [1] },
                                { t: 63, s: [0] }
                            ],
                            ix: 10
                        },
                        p: {
                            a: 1,
                            k: [
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 0.167, y: 0.167 },
                                    t: 0,
                                    s: [216, 64, 0],
                                    to: [-0.417, 1.25, 0],
                                    ti: [0, 5.125, 0]
                                },
                                {
                                    i: { x: 0, y: 1 },
                                    o: { x: 0.333, y: 0 },
                                    t: 6,
                                    s: [213.5, 71.5, 0],
                                    to: [0, -5.125, 0],
                                    ti: [-0.417, 0, 0]
                                },
                                {
                                    i: { x: 0.667, y: 1 },
                                    o: { x: 1, y: 0 },
                                    t: 30,
                                    s: [216, 33.25, 0],
                                    to: [0.417, 0, 0],
                                    ti: [0, -5.125, 0]
                                },
                                {
                                    i: { x: 0.833, y: 0.833 },
                                    o: { x: 0.333, y: 0 },
                                    t: 44.4,
                                    s: [216, 71.5, 0],
                                    to: [0, 5.125, 0],
                                    ti: [0, 1.25, 0]
                                },
                                { t: 49.80078125, s: [216, 64, 0] }
                            ],
                            ix: 2,
                            l: 2
                        },
                        a: { a: 0, k: [251, 96.482, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 6.176],
                                                [0, 0],
                                                [8.553, 0],
                                                [0, 0],
                                                [0, -6.135],
                                                [0, 0],
                                                [0, -4.188],
                                                [0, 0]
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, -4.147],
                                                [0, 0],
                                                [0, -6.176],
                                                [0, 0],
                                                [-8.553, 0],
                                                [0, 0],
                                                [0, 6.135],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            v: [
                                                [15.498, 18.704],
                                                [15.498, 11.19],
                                                [15.498, -7.514],
                                                [15.498, -7.514],
                                                [0, -18.704],
                                                [0, -18.704],
                                                [-15.498, -7.588],
                                                [-15.498, -7.588],
                                                [-15.498, 11.116],
                                                [-15.498, 18.704]
                                            ],
                                            c: false
                                        },
                                        ix: 2
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ty: 'st',
                                    c: {
                                        a: 0,
                                        k: [0.114, 0.192, 0.275, 1],
                                        ix: 3,
                                        x: "var $bm_rt;\n$bm_rt = comp('wired-outline-193-bell-notification').layer('control').effect('primary')('Color');"
                                    },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: {
                                        a: 0,
                                        k: 12,
                                        ix: 5,
                                        x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-193-bell-notification').layer('control').effect('stroke')('Menu'));"
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: '.primary',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                    cl: 'primary'
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [251.161, 95.654], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform'
                                }
                            ],
                            nm: 'Group 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false
                        },
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [53.036, 0],
                                                [0, 0],
                                                [-0.234, -48.704],
                                                [0, 0],
                                                [-0.001, -0.415],
                                                [0, 0],
                                                [13.879, -22.533],
                                                [0, 0],
                                                [-0.06, 0],
                                                [0, 0],
                                                [-55.19, 0.005],
                                                [0, 0],
                                                [0.03, 0.043],
                                                [0, 0],
                                                [12.916, 23.431],
                                                [0, 0],
                                                [0, 0.297],
                                                [0, 0],
                                                [-0.001, 47.873]
                                            ],
                                            o: [
                                                [0.001, -47.873],
                                                [0, 0],
                                                [-53.036, 0],
                                                [0, 0],
                                                [0.234, 48.704],
                                                [0, 0],
                                                [0.001, 0.415],
                                                [0, 0],
                                                [-13.879, 22.533],
                                                [0, 0],
                                                [0.06, 0],
                                                [0, 0],
                                                [55.19, -0.005],
                                                [0, 0],
                                                [-0.03, -0.043],
                                                [0, 0],
                                                [-12.916, -23.431],
                                                [0, 0],
                                                [0, -0.297],
                                                [0, 0]
                                            ],
                                            v: [
                                                [97.337, -43.086],
                                                [1.241, -129.828],
                                                [1.241, -129.828],
                                                [-94.433, -41.58],
                                                [-94.433, -41.58],
                                                [-94.007, 47.42],
                                                [-94.007, 47.42],
                                                [-119.153, 89],
                                                [-119.153, 89],
                                                [-144.193, 129.828],
                                                [-144.193, 129.828],
                                                [-44.085, 129.818],
                                                [44.247, 129.81],
                                                [144.193, 129.722],
                                                [144.193, 129.722],
                                                [120.737, 87.188],
                                                [120.737, 87.188],
                                                [97.335, 44.194],
                                                [97.335, 44.194],
                                                [97.337, -43.086]
                                            ],
                                            c: true
                                        },
                                        ix: 2
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ty: 'st',
                                    c: {
                                        a: 0,
                                        k: [0.114, 0.192, 0.275, 1],
                                        ix: 3,
                                        x: "var $bm_rt;\n$bm_rt = comp('wired-outline-193-bell-notification').layer('control').effect('primary')('Color');"
                                    },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: {
                                        a: 0,
                                        k: 12,
                                        ix: 5,
                                        x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-193-bell-notification').layer('control').effect('stroke')('Menu'));"
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: '.primary',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                    cl: 'primary'
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [250, 244.186], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform'
                                }
                            ],
                            nm: 'Group 2',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 2,
                            mn: 'ADBE Vector Group',
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 300,
                    st: 0,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 2,
                    ty: 4,
                    nm: 'Shape Layer 3',
                    parent: 1,
                    td: 1,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [250, 95.482, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [0, -44, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [400, 400, 100], ix: 6, l: 2 }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    ind: 0,
                                    ty: 'sh',
                                    ix: 1,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            v: [
                                                [4.24, -48.775],
                                                [-3.509, -48.775],
                                                [-3.509, -43.217],
                                                [-3.509, -39.423],
                                                [4.24, -39.423],
                                                [4.24, -43.18]
                                            ],
                                            c: true
                                        },
                                        ix: 2
                                    },
                                    nm: 'Path 2',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ind: 1,
                                    ty: 'sh',
                                    ix: 2,
                                    ks: {
                                        a: 0,
                                        k: {
                                            i: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            o: [
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0],
                                                [0, 0]
                                            ],
                                            v: [
                                                [24.41, -39.423],
                                                [-23.639, -39.423],
                                                [-23.427, 4.701],
                                                [-23.426, 5.077],
                                                [-36, 25.491],
                                                [-35.946, 25.491],
                                                [36.137, 25.484],
                                                [36.11, 25.445],
                                                [24.409, 4.217],
                                                [24.409, 3.948]
                                            ],
                                            c: true
                                        },
                                        ix: 2
                                    },
                                    nm: 'Path 1',
                                    mn: 'ADBE Vector Shape - Group',
                                    hd: false
                                },
                                {
                                    ty: 'fl',
                                    c: { a: 0, k: [1, 0, 0, 1], ix: 4 },
                                    o: { a: 0, k: 100, ix: 5 },
                                    r: 1,
                                    bm: 0,
                                    nm: 'Fill 1',
                                    mn: 'ADBE Vector Graphic - Fill',
                                    hd: false
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0, 0], ix: 2 },
                                    a: { a: 0, k: [0, 0], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: { a: 0, k: 0, ix: 6 },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform'
                                }
                            ],
                            nm: 'Shape 1',
                            np: 3,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 300,
                    st: 0,
                    bm: 0
                },
                {
                    ddd: 0,
                    ind: 3,
                    ty: 4,
                    nm: 'Shape Layer 2',
                    parent: 1,
                    tt: 2,
                    sr: 1,
                    ks: {
                        o: { a: 0, k: 100, ix: 11 },
                        r: { a: 0, k: 0, ix: 10 },
                        p: { a: 0, k: [251, 148.482, 0], ix: 2, l: 2 },
                        a: { a: 0, k: [0.25, -30.75, 0], ix: 1, l: 2 },
                        s: { a: 0, k: [400, 400, 100], ix: 6, l: 2 }
                    },
                    ao: 0,
                    shapes: [
                        {
                            ty: 'gr',
                            it: [
                                {
                                    d: 1,
                                    ty: 'el',
                                    s: { a: 0, k: [19.25, 19.25], ix: 2 },
                                    p: { a: 0, k: [0, 0], ix: 3 },
                                    nm: 'Ellipse Path 1',
                                    mn: 'ADBE Vector Shape - Ellipse',
                                    hd: false
                                },
                                {
                                    ty: 'st',
                                    c: {
                                        a: 0,
                                        k: [0.208, 0.8, 0.729, 1],
                                        ix: 3,
                                        x: "var $bm_rt;\n$bm_rt = comp('wired-outline-193-bell-notification').layer('control').effect('secondary')('Color');"
                                    },
                                    o: { a: 0, k: 100, ix: 4 },
                                    w: {
                                        a: 0,
                                        k: 3.15,
                                        ix: 5,
                                        x: "var $bm_rt;\n$bm_rt = $bm_mul($bm_div(value, 2), comp('wired-outline-193-bell-notification').layer('control').effect('stroke')('Menu'));"
                                    },
                                    lc: 2,
                                    lj: 2,
                                    bm: 0,
                                    nm: '.secondary',
                                    mn: 'ADBE Vector Graphic - Stroke',
                                    hd: false,
                                    cl: 'secondary'
                                },
                                {
                                    ty: 'tr',
                                    p: { a: 0, k: [0.125, -21.875], ix: 2 },
                                    a: { a: 0, k: [0, -50], ix: 1 },
                                    s: { a: 0, k: [100, 100], ix: 3 },
                                    r: {
                                        a: 1,
                                        k: [
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 0, s: [0] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 6, s: [26] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 12, s: [-22] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 18, s: [26] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.167], y: [0.167] }, t: 24, s: [-24] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.167], y: [0.167] }, t: 30, s: [22] },
                                            { i: { x: [0.833], y: [0.833] }, o: { x: [0.333], y: [0] }, t: 38.4, s: [-19] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.167], y: [0.167] }, t: 46.801, s: [24] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 55, s: [-8] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 64.689, s: [6] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 74.381, s: [-4] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 82.582, s: [2] },
                                            { i: { x: [0.667], y: [1] }, o: { x: [0.333], y: [0] }, t: 89.289, s: [-1] },
                                            { t: 96, s: [0] }
                                        ],
                                        ix: 6
                                    },
                                    o: { a: 0, k: 100, ix: 7 },
                                    sk: { a: 0, k: 0, ix: 4 },
                                    sa: { a: 0, k: 0, ix: 5 },
                                    nm: 'Transform'
                                }
                            ],
                            nm: 'Ellipse 1',
                            np: 2,
                            cix: 2,
                            bm: 0,
                            ix: 1,
                            mn: 'ADBE Vector Group',
                            hd: false
                        }
                    ],
                    ip: 0,
                    op: 300,
                    st: 0,
                    bm: 0
                }
            ]
        }
    ],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 3,
            nm: 'control',
            sr: 1,
            ks: {
                o: { a: 0, k: 0, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [0, 0], ix: 2, l: 2 },
                a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
            },
            ao: 0,
            ef: [
                {
                    ty: 5,
                    nm: 'stroke',
                    np: 3,
                    mn: 'Pseudo/@@4i/A000QRjWsz2UI8rIC5A',
                    ix: 1,
                    en: 1,
                    ef: [{ ty: 7, nm: 'Menu', mn: 'Pseudo/@@4i/A000QRjWsz2UI8rIC5A-0001', ix: 1, v: { a: 0, k: 2, ix: 1 } }]
                },
                {
                    ty: 5,
                    nm: 'primary',
                    np: 3,
                    mn: 'ADBE Color Control',
                    ix: 2,
                    en: 1,
                    ef: [{ ty: 2, nm: 'Color', mn: 'ADBE Color Control-0001', ix: 1, v: { a: 0, k: [0.114, 0.192, 0.275], ix: 1 } }]
                },
                {
                    ty: 5,
                    nm: 'secondary',
                    np: 3,
                    mn: 'ADBE Color Control',
                    ix: 3,
                    en: 1,
                    ef: [{ ty: 2, nm: 'Color', mn: 'ADBE Color Control-0001', ix: 1, v: { a: 0, k: [0.208, 0.8, 0.729], ix: 1 } }]
                }
            ],
            ip: 0,
            op: 409,
            st: 0,
            bm: 0
        },
        {
            ddd: 0,
            ind: 3,
            ty: 0,
            nm: 'hover-ring',
            refId: 'comp_1',
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [215, 215, 0], ix: 2, l: 2 },
                a: { a: 0, k: [215, 215, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 }
            },
            ao: 0,
            w: 430,
            h: 430,
            ip: 0,
            op: 106,
            st: 0,
            bm: 0
        }
    ],
    markers: [{ tm: 0, cm: 'default:hover-ring', dr: 96 }]
};
